import Vue from 'vue'
import Vuex from 'vuex'
import { apiAxios } from '@/router/auth'
import auth from './modules/auth'
import group from './modules/group'
import manager from './modules/manager'
import user from './modules/user'

Vue.use(Vuex)

export function toast (titol, missatge) {
  return {
    title: titol,
    body: missatge,
    config: {
      timeout: 5000,
      showProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true
    }
  }
}

export default new Vuex.Store({
  modules: {
    auth,
    user,
    manager,
    group
  },
  state: {
    classroom_tickets: [],
    categories: [],
    groups: [],
    incidences: [],
    classrooms: [],
    dedicated_times: [],
    priorities: [],
    users: [],
    managers: [],
    states: [],
    ticket: null,
    files: []
  },

  getters: {},
  // Llamadas a la api
  actions: {
    fetchClassroomTickets ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/classrooms/tickets`).then(response => {
          commit('setClassroomTickets', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchCategories ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/categories`).then(response => {
          commit('setCategories', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchGroups ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/groups`).then(response => {
          commit('setGroups', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchIncidences ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/incidences`).then(response => {
          commit('setIncidences', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchClassrooms ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/classrooms`).then(response => {
          commit('setClassrooms', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchHoresDedicades ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/actions_times`).then(response => {
          commit('setDedicatedTimes', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchPrioritats ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/priorities`).then(response => {
          commit('setPriorities', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchUsers ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/users`).then(response => {
          commit('setUsers', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchGroupManagers ({ commit }, groupId) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`groups/${groupId}/managers`).then(response => {
          commit('setGroupManagers', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchStates ({ commit }) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/states`).then(response => {
          commit('setStates', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    fetchTicket ({ dispatch, commit }, ticketId) {
      return new Promise((resolve, reject) => {
        apiAxios.get(`/tickets/${ticketId}`, {
          params: {
            user: this.getters.getUser.id
          }
        }).then(response => {
          dispatch('fetchTicketFiles', { ticketId: response.data.id, files: response.data.files })
          commit('setTicket', response.data)
          resolve()
        }).catch(e => {
          console.log(e)
          reject(e.response)
        })
      })
    },
    createTicket (context, ticket) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Creant incidència...', () => new Promise((resolve, reject) => {
        apiAxios.post('/tickets', ticket, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
          context.commit('addTicket', response.data)
          resolve(toast('Creada', `Incidència amb id ${response.data.id} creada correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha creat correctament'))
        })
      }))
    },
    createAction (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Afegint intervenció...', () => new Promise((resolve, reject) => {
        apiAxios.post(`/actions/${data.get('ticket_id')}`, data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => {
          if (['reactivate', 'addedinfo'].includes(data.get('transition'))) {
            context.dispatch('userTransitionTicket', {
              ticket_id: data.get('ticket_id'),
              codi_xarxa: data.get('user'),
              transition: data.get('transition')
            })
          } else if (['close','cancel'].includes(data.get('transition'))) {
            context.dispatch('managerTransitionTicket', {
              ticket_id: data.get('ticket_id'),
              codi_xarxa: data.get('user'),
              transition: data.get('transition')
            })
          } else {
            if (response.data.files) {
              context.dispatch('fetchTicketFiles', { ticketId: response.data.id, files: response.data.files })
            }
            context.commit('setTicket', response.data)
          }
          resolve(toast(`Afegida`, 'La intervenció ha estat afegida correctament'))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La intervenció no s\'ha afegit correctament'))
        })
      }))
    },
    deleteAction (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Eliminant intervenció...', () => new Promise((resolve, reject) => {
        apiAxios.delete(`/actions/${data.actionId}`).then(response => {
          context.dispatch('fetchTicket', data.ticketId)
          resolve(toast(`Eliminada`, 'La intervenció ha estat eliminada correctament'))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La intervenció no s\'ha eliminat correctament'))
        })
      }))
    },
    changePriorityTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Canviant la prioritat de la incidència...', () => new Promise((resolve, reject) => {
        apiAxios.put(`/tickets/${data.ticket_id}/priority`, data).then(response => {
          context.commit('setTicket', response.data)
          resolve(toast('Modificat', `Incidència amb id ${response.data.id} modificada correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    userFollowTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Afegint usuaris a la incidència...', () => new Promise((resolve, reject) => {
        apiAxios.post(`/users/${data.ticketId}`, data).then(response => {
          context.commit('setTicket', response.data)
          resolve(toast('Afegits', `Els usuaris han estat afegits a la incidència correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    userUnfollowTicket (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Eliminant usuaris de la incidència...', () => new Promise((resolve, reject) => {
        apiAxios.delete(`/users/${data.ticketId}/${data.codi_xarxa}`).then(response => {
          context.commit('setTicket', response.data)
          resolve(toast('Afegits', `Els usuaris han estat eliminats de la incidència correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    addFiles (context, data) {
      return this._vm.$snotify.async('Esperant resposta del servidor', 'Afegint arxius a la incidència...', () => new Promise((resolve, reject) => {
        apiAxios.post(`/ticket/files`, data, { headers: { 'Content-Type': 'multipart/form-data' } }
        ).then(response => {
          if (response.data.files) {
            context.dispatch('fetchTicketFiles', { ticketId: response.data.id, files: response.data.files })
          }
          context.commit('setTicket', response.data)
          resolve(toast('Afegits', `Els fitxers han estat afegits a la incidència correctament`))
        }).catch(e => {
          console.log(e)
          reject(toast('Error', 'La incidència no s\'ha modificat correctament'))
        })
      }))
    },
    fetchTicketFiles (context, data) {
      const ticketFiles = []
      return new Promise((resolve, reject) => {
        if (data.files) {
          data.files.forEach(file => {
            apiAxios.get(`/ticket/file/${data.ticketId}/${file}`, { responseType: 'arraybuffer' }).then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]))
              ticketFiles.push({ name: file, blob: url })
            })
          })
        }
        context.commit('setFiles', ticketFiles)
        resolve()
      })
    }
  },
  mutations: {
    setCategories (state, categories) {
      state.categories = categories
    },
    setGroups (state, groups) {
      state.groups = groups
    },
    setIncidences (state, incidences) {
      state.incidences = incidences
    },
    setClassrooms (state, classrooms) {
      state.classrooms = classrooms
    },
    setDedicatedTimes (state, times) {
      state.dedicated_times = times
    },
    setClassroomTickets (state, tickets) {
      state.classroom_tickets = tickets
    },
    setPriorities (state, priorities) {
      state.priorities = priorities
    },
    setTicket (state, ticket) {
      state.ticket = ticket
    },
    setUsers (state, users) {
      state.users = users
    },
    setGroupManagers (state, managers) {
      state.managers = managers
    },
    setStates (state, states) {
      state.states = states
    },
    setFiles (state, files) {
      state.files = files
    },
    updateActions (state, actionId) {
      var elementPos = state.ticket.accions.map(function (x) { return x.id }).indexOf(actionId)
      state.ticket.accions.splice(elementPos, 1)
    }
  }
})
